"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.H6 = exports.H6CSS = exports.H5 = exports.H5CSS = exports.H4 = exports.H4CSS = exports.H3 = exports.H3CSS = exports.H2 = exports.H2CSS = exports.H1 = exports.H1CSS = exports.H0 = exports.H0CSS = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _typography = _interopRequireDefault(require("./typography.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 1em;\n  line-height: 1.5em;\n  font-weight: 400;\n  @media screen and (max-width: 45em) {\n    font-size: 13px;\n    line-height: 13px;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 1.25em;\n  line-height: 1.5em;\n  font-weight: 400;\n  @media screen and (max-width: 45em) {\n    font-size: 18px;\n    line-height: 18px;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 1.5em;\n  line-height: 36px;\n  font-weight: 400;\n  @media screen and (max-width: 45em) {\n    font-size: 23px;\n    line-height: 23px;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 2em;\n  line-height: 45px;\n  font-weight: 400;\n  @media screen and (max-width: 45em) {\n    font-size: 27px;\n    line-height: 29px;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 40px;\n  line-height: 48px;\n  font-weight: 500;\n  @media screen and (max-width: 45em) {\n    font-size: 32px;\n    line-height: 32px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 52px;\n  font-weight: 500;\n  line-height: 58px;\n  letter-spacing: -0.5px;\n  @media screen and (max-width: 45em) {\n    font-size: 40px;\n    line-height: 48px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 60px;\n  font-weight: 500;\n  line-height: 60px;\n  letter-spacing: -0.5px;\n  @media screen and (max-width: 45em) {\n    font-size: 44px;\n    line-height: 44px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var H0CSS = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.theme.colors.black['300'];
});
exports.H0CSS = H0CSS;

var H0 = _styledComponents["default"].h1(_templateObject2(), H0CSS, _typography["default"]);

exports.H0 = H0;
var H1CSS = (0, _styledComponents.css)(_templateObject3(), function (props) {
  return props.theme.colors.black['300'];
});
exports.H1CSS = H1CSS;

var H1 = _styledComponents["default"].h1(_templateObject4(), H1CSS, _typography["default"]);

exports.H1 = H1;
var H2CSS = (0, _styledComponents.css)(_templateObject5(), function (props) {
  return props.theme.colors.black['300'];
});
exports.H2CSS = H2CSS;

var H2 = _styledComponents["default"].h2(_templateObject6(), H2CSS, _typography["default"]);

exports.H2 = H2;
var H3CSS = (0, _styledComponents.css)(_templateObject7(), function (props) {
  return props.theme.colors.black['300'];
});
exports.H3CSS = H3CSS;

var H3 = _styledComponents["default"].h3(_templateObject8(), H3CSS, _typography["default"]);

exports.H3 = H3;
var H4CSS = (0, _styledComponents.css)(_templateObject9(), function (props) {
  return props.theme.colors.black['300'];
});
exports.H4CSS = H4CSS;

var H4 = _styledComponents["default"].h4(_templateObject10(), H4CSS, _typography["default"]);

exports.H4 = H4;
var H5CSS = (0, _styledComponents.css)(_templateObject11(), function (props) {
  return props.theme.colors.black['300'];
});
exports.H5CSS = H5CSS;

var H5 = _styledComponents["default"].h5(_templateObject12(), H5CSS, _typography["default"]);

exports.H5 = H5;
var H6CSS = (0, _styledComponents.css)(_templateObject13(), function (props) {
  return props.theme.colors.black['300'];
});
exports.H6CSS = H6CSS;

var H6 = _styledComponents["default"].h6(_templateObject14(), H6CSS, _typography["default"]);

exports.H6 = H6;